import { render } from "./PruefungBetreuungsverhaeltnis.pug?vue&type=template&id=adc6c4ce&lang=pug"
import script from "./PruefungBetreuungsverhaeltnis.js?vue&type=script&lang=js"
export * from "./PruefungBetreuungsverhaeltnis.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__